import React from 'react';
import { motion } from 'framer-motion';
const packs = [{
  icon: '📘',
  title: 'Pack I – Diseños de Alto Impacto Comercial',
  desc: '400 prompts optimizados para generar diseños llamativos, claros y vendibles. 40 por cada categoría.',
  color: 'border-blue-500',
  bullets: ['400 prompts listos para usar', '40 prompts por cada categoría', 'Estética streetwear y tendencia', 'Estructuras pensadas para impresión', 'Alto contraste y claridad visual']
}, {
  icon: '📗',
  title: 'Pack II – Nichos Rentables',
  desc: '400 prompts enfocados en categorías que ya venden. 40 por cada nicho validado.',
  color: 'border-green-500',
  bullets: ['400 prompts listos para usar', '40 prompts por cada categoría', 'Anime, gaming, frases, dark, animales', 'Subnichos listos para testear', 'Diseños orientados a demanda real']
}, {
  icon: '📕',
  title: 'Pack III – Vectorización y Producción',
  desc: '400 prompts diseñados para facilitar el paso a producción real. 40 por cada categoría.',
  color: 'border-red-500',
  bullets: ['400 prompts listos para usar', '40 prompts por cada categoría', 'Estilo flat optimizado para impresión', 'Bordes limpios y definidos', 'Listos para serigrafía o POD']
}, {
  icon: '📙',
  title: 'Pack IV – Variaciones y Escalado',
  desc: '400 prompts para generar variaciones infinitas y escalar tu catálogo. 40 por cada categoría.',
  color: 'border-orange-500',
  bullets: ['400 prompts listos para usar', '40 prompts por cada categoría', 'Variaciones automáticas por concepto', 'Escalado de catálogo en horas', 'Producción masiva sin perder calidad']
}];
export function PacksSection() {
  return <section className="py-12 md:py-24 bg-neutral-950" data-id="element-50">
      <div className="container mx-auto px-4" data-id="element-51">
        <div className="text-center mb-8 md:mb-16" data-id="element-52">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-bebas text-5xl md:text-6xl text-white uppercase tracking-wide mb-4" data-id="element-53">
            ¿Qué incluye <span className="text-brand-500" data-id="element-54">Prompt Wear?</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-xl text-neutral-400 max-w-3xl mx-auto" data-id="element-55">
            4 packs con 400 prompts cada uno — 40 por cada categoría — diseñados
            para generar diseños vendibles desde el primer día.
            <br className="hidden md:block" data-id="element-56" />
            <span className="text-neutral-300 mt-2 block" data-id="element-57">
              1.600 prompts en total, organizados por categorías para que puedas
              ejecutar sin pensar.
            </span>
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 max-w-5xl mx-auto" data-id="element-58">
          {packs.map((pack, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`bg-neutral-900 rounded-xl p-5 md:p-8 border-l-4 ${pack.color} border-y border-r border-y-neutral-800 border-r-neutral-800 hover:bg-neutral-800/50 transition-colors`} data-id="element-59">
              <div className="text-4xl mb-4" data-id="element-60">{pack.icon}</div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-61">
                {pack.title}
              </h3>
              <p className="text-neutral-400 text-sm mb-6" data-id="element-62">{pack.desc}</p>

              <ul className="space-y-3" data-id="element-63">
                {pack.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-2 text-sm text-neutral-300" data-id="element-64">
                    <span className="text-brand-500 mt-0.5" data-id="element-65">✓</span>
                    <span data-id="element-66">{bullet}</span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>
      </div>
    </section>;
}